import "./scss/App.scss";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MyProvider from "./context/Myprovider";
import Header from "./components/Header";
import Products from "./components/Products";
import DetailProduct from "./components/DetailProduct";
import Login from "./components/Login";
import Register from "./components/Register";
import OrderHistory from "./components/OrderHistory";
import OrderDetails from "./components/OrderDetails";
import Cart from "./components/Cart";
import NotFound from "./components/NotFound";
import Categories from "./components/Categories";
import CreateProduct from "./components/CreateProduct";
import Dashboard from "./components/Dashboard";
import AdminRoute from "./components/AdminRoute";
import UserRoute from "./components/UserRoute";
import UserVerification from "./components/UserVerification";
import ViewOrders from "./components/ViewOrders";
import Footer from "./components/Footer";
import AddDeliveryAddress from "./components/AddDeliveryAddress";
import AddBillAddress from "./components/AddBillAddress";

const App = () => {
  return (
    <MyProvider>
      <Router>
        <div className="App">
          <Header />
          <div className="main">
            <Switch>
              <Route
                exact
                path="/users/verify/:emailVerifToken"
                component={UserVerification}
              />
              <Route path="/" exact component={Products} />
              <Route path="/detail/:id" exact component={DetailProduct} />

              <Route path="/login" exact component={Login} />
              <Route path="/register" exact component={Register} />

              <AdminRoute path="/category" exact component={Categories} />
              <AdminRoute
                path="/create_product"
                exact
                component={CreateProduct}
              />
              <AdminRoute
                path="/edit_product/:id"
                exact
                component={CreateProduct}
              />
              <AdminRoute exact path="/allorders" component={ViewOrders} />
              <UserRoute path="/dashboard" exact component={Dashboard} />

              <UserRoute path="/orderhistory" exact component={OrderHistory} />
              <UserRoute
                path="/orderdetails/:id"
                exact
                component={OrderDetails}
              />
              <UserRoute
                path="/addAddress"
                exact
                component={AddDeliveryAddress}
              />
              <UserRoute
                path="/add-bill-address"
                exact
                component={AddBillAddress}
              />

              <UserRoute path="/cart" exact component={Cart} />

              <Route path="*" exact component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    </MyProvider>
  );
};

export default App;
